import { mapValues } from 'lodash';
export const overrides = {
    s: 'Just now',
    ss: '<1m',
    m: 'a minute',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: '1mo',
    MM: '%dmo',
    y: '1y',
    yy: '%dy'
};
const format = (value, withoutSuffix, key, isFuture)=>{
    const text = overrides[key].replace('%d', value.toString());
    if (withoutSuffix || text === overrides.s) {
        return text;
    }
    const pattern = isFuture ? 'in %s' : '%s ago';
    return pattern.replace('%s', text);
};
export const localeData = {
    relativeTime: {
        future: '%s',
        past: '%s',
        ...mapValues(overrides, ()=>format)
    }
};
